export const FW_STORAGE_KEY = 'fourthwall';
export class LocalStorage {
    constructor() {
        this.setItem = (key, value) => {
            localStorage.setItem(key, value);
        };
        this.setObjectItem = (key, value) => {
            this.setItem(key, JSON.stringify(value));
        };
        this.getItem = (key) => {
            return localStorage.getItem(key);
        };
        this.getObjectItem = (key) => {
            try {
                return JSON.parse(this.getItem(key) || '');
            }
            catch (error) {
                return undefined;
            }
        };
    }
}
const fwLocalStorage = new LocalStorage();
export const useLocalStorage = (rootKey = FW_STORAGE_KEY) => {
    const localStorage = {
        get: (key) => {
            const store = fwLocalStorage.getObjectItem(rootKey);
            return store ? store[key] : undefined;
        },
        set: (key, value) => {
            const store = fwLocalStorage.getObjectItem(rootKey);
            return fwLocalStorage.setObjectItem(rootKey, Object.assign(Object.assign({}, store), { [key]: value }));
        },
    };
    return { localStorage };
};
